import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutGrid, Package, Receipt, Store, LogOut, Tag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/admin", label: "Overview", icon: LayoutGrid },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: Receipt },
  { to: "/admin/coupons", label: "Coupons", icon: Tag },
];

export default function AdminLayout({ children, title, actions }) {
  const loc = useLocation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#faf7f2] text-[#1a1d29] flex" data-testid="admin-layout">
      <aside className="w-64 border-r border-[#e0d8c8] p-6 flex flex-col shrink-0 bg-white">
        <Link to="/" className="font-display text-xl font-semibold" data-testid="admin-brand">
          shopnest<span className="text-[#c8532e]">.</span>
        </Link>
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#6b6b6b] mt-1">Studio Panel</div>

        <nav className="mt-10 space-y-1">
          {items.map((it) => {
            const Active = loc.pathname === it.to;
            const Icon = it.icon;
            return (
              <Link
                key={it.to}
                to={it.to}
                className={`flex items-center gap-3 px-3 h-10 rounded-md text-sm ${
                  Active ? "bg-[#1a1d29] text-white" : "hover:bg-[#faf7f2]"
                }`}
                data-testid={`admin-nav-${it.label.toLowerCase()}`}
              >
                <Icon className="w-4 h-4" /> {it.label}
              </Link>
            );
          })}
        </nav>

        <div className="mt-auto pt-6 border-t border-[#e0d8c8]">
          <div className="text-xs text-[#6b6b6b] truncate">{user?.email}</div>
          <Link to="/" className="mt-3 flex items-center gap-2 text-xs uppercase tracking-[0.16em] hover-underline" data-testid="admin-view-store">
            <Store className="w-4 h-4" /> View Store
          </Link>
          <button
            onClick={() => {
              logout();
              navigate("/");
            }}
            className="mt-3 flex items-center gap-2 text-xs uppercase tracking-[0.16em] hover-underline"
            data-testid="admin-logout"
          >
            <LogOut className="w-4 h-4" /> Sign Out
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <header className="bg-white border-b border-[#e0d8c8] h-16 flex items-center justify-between px-8">
          <h1 className="font-display text-2xl font-semibold" data-testid="admin-page-title">{title}</h1>
          <div>{actions}</div>
        </header>
        <div className="p-8">{children}</div>
      </div>
    </div>
  );
}
